import { useState, useMemo, useCallback } from 'react';

interface PaginationProps<T> {
  data: T[];
  initialCount?: number;
  loadCount?: number;
}

export const usePagination = <T>({ data, initialCount = 10, loadCount = 5 }: PaginationProps<T>) => {
  const [visibleCount, setVisibleCount] = useState(initialCount);
  const [isLoading, setIsLoading] = useState(false);

  const visibleItems = useMemo(() => {
    return data.slice(0, visibleCount);
  }, [data, visibleCount]);

  const isAtBottom = visibleCount >= data.length;

  const loadMore = useCallback(() => {
    if (!isAtBottom) {
      setIsLoading(true);
      // Simulate a delay for loading
      setTimeout(() => {
        setVisibleCount(prevCount => Math.min(prevCount + loadCount, data.length));
        setIsLoading(false);
      }, 500);
    }
  }, [isAtBottom, loadCount, data.length]);

  return {
    visibleItems,
    isAtBottom,
    loadMore,
    isLoading,
  };
};
